import { MainInner } from "@/styles/global";
import { Paragraph, TextLinkCss, h2, h5, h6 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Inner = styled(MainInner)`
  gap: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 40px;
  }
`;

const Title = styled(h2)``;

const BlockWrapper = styled.div``;

const BlockTitleWrapper = styled.div`
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  border-radius: 4px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.darkPurple};
`;

const BlockTitle = styled(h5)`
  color: ${({ theme }) => theme.colors.coreLight};
`;

const CardsWrapper = styled.div`
  display: grid;
  gap: 16px;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.coreDark};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 28px;
    padding: 40px 24px;
  }
`;

const Card = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.coreLight};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 300px;
    min-height: 217px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CardTitle = styled(h5)``;

const CardText = styled(Paragraph)``;

const CardImage = styled(GatsbyImage)`
  height: 100%;
  aspect-ratio: 1/1;
  padding: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 317px;
  }
`;

const CardSmallTitle = styled(h6)`
  font-size: 18px;
`;

const Link = styled.a`
  ${TextLinkCss}
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.primaryPurple};

  svg path {
    stroke: ${({ theme }) => theme.colors.primaryPurple};
  }
`;

const S = {
  Inner,
  Title,
  BlockWrapper,
  BlockTitleWrapper,
  BlockTitle,
  CardsWrapper,
  Card,
  CardText,
  TextWrapper,
  CardTitle,
  CardImage,
  CardSmallTitle,
  Link,
};

export default S;
